const memoryStore = new Map();

const LEGACY_LOCAL_STORAGE_KEYS = [
  "user",
  "token",
  "blackroth_admin_users",
  "blackroth_blog_posts",
  "blackroth_job_posts",
  "blackroth_login_history_v1",
];

const canUseBrowserStorage = () => typeof window !== "undefined";

const getSessionStorage = () => {
  if (!canUseBrowserStorage()) return null;

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const clearLegacyLocalStorage = () => {
  if (!canUseBrowserStorage()) return;

  try {
    LEGACY_LOCAL_STORAGE_KEYS.forEach((key) => {
      window.localStorage.removeItem(key);
    });
  } catch {
    // Ignore storage access errors and keep using memory only.
  }
};

clearLegacyLocalStorage();

export const memoryStorage = {
  getItem(key) {
    const sessionStorageRef = getSessionStorage();
    if (sessionStorageRef) {
      const storedValue = sessionStorageRef.getItem(key);
      if (storedValue !== null) {
        memoryStore.set(key, storedValue);
        return storedValue;
      }
    }

    return memoryStore.has(key) ? memoryStore.get(key) : null;
  },

  setItem(key, value) {
    const normalizedValue = String(value);
    memoryStore.set(key, normalizedValue);

    const sessionStorageRef = getSessionStorage();
    if (sessionStorageRef) {
      sessionStorageRef.setItem(key, normalizedValue);
    }
  },

  removeItem(key) {
    memoryStore.delete(key);

    const sessionStorageRef = getSessionStorage();
    if (sessionStorageRef) {
      sessionStorageRef.removeItem(key);
    }
  },

  clear() {
    memoryStore.clear();

    const sessionStorageRef = getSessionStorage();
    if (sessionStorageRef) {
      sessionStorageRef.clear();
    }
  },
};
 